import { createAsyncThunk } from "@reduxjs/toolkit";
//import axios from "axios";
import { userId } from "src/helpers/user_id";
//import { API_URL } from "src/utils/apiConfig";
import { apiClient } from '../../helpers/api_helper';

export const getUsers = createAsyncThunk("users/getUsers", async () => {
  try {
    const response = await apiClient.get(`/accounts/api/users/`);

    return response;
  } catch (error) {
    return error;
  }
});

export const getUserById = createAsyncThunk("users/getUserById", async (id: any) => {
    try {
      const response = await apiClient.get(`/accounts/api/user/${id}`);

      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addUser = createAsyncThunk("users/addUser", async (user: any) => {
  try {
    const response = await apiClient.post(`/accounts/api/create-user/`, {
        first_name: user.first_name,
        last_name: user.last_name,
        supervisor_id: user.superior,
        role: user.role,
        username: user.username,
        email: user.email,
        password: user.password,
        telephone: `+258${user.telephone}`,
        create_user: userId,
        update_user: userId,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
});

export const updateUser = createAsyncThunk("users/updateUser", async (user: any, { dispatch }) => {
    try {
      const response = await apiClient.put(`/accounts/api/update-user/${user.id}`, {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          status: user.status,
          role: user.role,
          supervisor_id: user.superior,
          telephone: `+258${user.telephone}`,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteUser = createAsyncThunk("users/delete", async (userId: any, { dispatch }) => {
    try {
      const response = await apiClient.delete(`/accounts/api/delete-user/${userId}`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const changePassword = createAsyncThunk("users/changePassword", async (user: any) => {
    try {
      const response = await apiClient.post(`/accounts/api/change-password/`,{
          old_password: user.old_password,
          new_password1: user.new_password1,
          new_password2: user.new_password2,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
